<template>
  <NavbarHeader />
  <router-view></router-view>

  <footer class="footer-section">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-4 mb-4 mb-lg-0">
          <div class="footer-brand mb-3">
            <img :src="require('@/assets/logo.png')" alt="Diskola Logo" height="40" class="me-2" />
            <span class="brand-text">diskola.id</span>
          </div>
          <p class="text-muted">Platform pendidikan digital terintegrasi untuk sekolah cerdas masa depan.</p>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">
          <h5 class="footer-heading">Hubungi Kami</h5>
          <ul class="list-unstyled contact-list">
            <li>
              <a
                :href="whatsappUrl"
                class="d-flex align-items-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-whatsapp me-2"></i> WhatsApp Support
              </a>
            </li>
            <li>
              <a href="#" class="d-flex align-items-center"> <i class="fab fa-instagram me-2"></i> Instagram </a>
            </li>
            <li>
              <a href="#" class="d-flex align-items-center"> <i class="fab fa-youtube me-2"></i> Youtube Channel </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom mt-5 pt-4 border-top">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="copyright-text mb-0">© {{ currentYear }} diskola.id. All Rights Reserved.</p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <div class="footer-links">
              <router-link to="/kebijakan-privasi">Kebijakan Privasi</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <button
    id="myBtn"
    class="scroll-top-btn"
    type="button"
    aria-label="Kembali ke atas"
    :class="{ 'scroll-top-btn--visible': showScrollTop }"
    @click="scrollToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
</template>

<style lang="scss">
@import "@/assets/scss/tokens";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.footer-section {
  background-color: var(--surface-elevated);
  padding: 80px 0 30px;
  margin-top: 80px;

  .brand-text {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    color: var(--color-primary);
    vertical-align: middle;
  }

  .footer-heading {
    color: var(--color-primary);
    margin-bottom: 1.5rem;
    font-weight: 600;
  }

  .contact-list {
    li {
      margin-bottom: 12px;

      a {
        color: var(--text-muted);
        &:hover {
          color: var(--color-primary);
          padding-left: 5px;
        }
      }
    }
  }

  .footer-bottom {
    border-color: var(--border) !important;

    .copyright-text {
      color: var(--text-faint);
      font-size: 0.9rem;
    }

    .footer-links {
      a {
        color: var(--text-faint);
        font-size: 0.9rem;
        text-decoration: none;
        &:hover {
          color: var(--color-primary);
        }
      }
    }
  }
}

.scroll-top-btn {
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  border: none;
  outline: none;
  background-color: var(--color-primary-solid);
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 50%;
  font-size: 18px;
  box-shadow: var(--shadow-md);
  transition: transform var(--dur-base) var(--ease-out), background-color var(--dur-base) var(--ease-out),
    opacity var(--dur-base) var(--ease-out);
  opacity: 0;
  pointer-events: none;

  &:hover {
    background-color: #034c56;
    transform: translateY(-3px);
  }
}

.scroll-top-btn--visible {
  opacity: 1;
  pointer-events: auto;
}
</style>
<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import NavbarHeader from "@/components/NavbarHeader.vue";
import { getWhatsAppUrl } from "@/services/whatsapp";

const currentYear = new Date().getFullYear();
const whatsappUrl = getWhatsAppUrl();
const showScrollTop = ref(false);
let ticking = false;

const updateScrollTopVisibility = () => {
  showScrollTop.value = window.scrollY > 160;
  ticking = false;
};

const onScroll = () => {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(updateScrollTopVisibility);
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

onMounted(() => {
  updateScrollTopVisibility();
  window.addEventListener("scroll", onScroll, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>
